import { Navigate, ReactLocation } from '@tanstack/react-location'
// Screens
import ActionsScreen from './screens/Actions'
import NotFoundScreen from 'CRM/screens/NotFound'
import RouteGuard from 'CRM/components/RouteGuard'
import HeaderLayout from './layouts/HeaderLayout'
import FloorPlansScreen from './screens/FloorPlans'
import FeaturedVideosScreen from './screens/FeaturedVideos'
import ImagesScreen from './screens/Images'
import ManagePropertyMainScreen from './screens/Property/ManageMain'
import ManagePropertyLineImagesScreen from './screens/Property/ManageLineImages'
import SigninScreen from './screens/Signin'
import { ROUTES } from './common/constants'
import ManageRealEstateCompaniesMainScreen from './screens/RealEstateCompanies/ManageMain'
import ManageRealEstateCompaniesEditScreen from './screens/RealEstateCompanies/Edit'
import PropertyEditScreen from './screens/Property/Edit'
import LineEditScreen from './screens/Property/Line/Edit'
import LevelEditScreen from './screens/Property/Line/Edit/components/Levels/Edit'
import ManageLineUnitsScreen from './screens/Property/Units/Manage'
import UnitsEditScreen from './screens/Property/Units/Edit'
import ManageLineDesignsScreen from './screens/Property/Designs/Manage'
import DesignsEditScreen from './screens/Property/Designs/DesignLayouts/Edit'
import RoomDesignsEditScreen from './screens/Property/Designs/RoomDesigns'
import EditPackageScreen from './screens/Property/Packages/Edit'
import ManagePackages from './screens/Property/Packages/Manage'
import EditLivingVariantsScreen from './screens/Living/Variants/Edit'
import ManageLivingVariantsScreen from './screens/Living/Variants/Manage'
import LivingDashboardScreen from './screens/Living/Dashboard'
import EditLivingLinksScreen from './screens/Living/Dashboard/LivingLinks/Edit'
import Manage3DModelsScreen from './screens/3DModels/Manage'
import Edit3DModelsScreen from './screens/3DModels/Edit'

export const routes = [
  {
    path: ROUTES.HOME,
    element: (
      <RouteGuard loggedOut>
        <ActionsScreen />
      </RouteGuard>
    ),
  },
  {
    path: ROUTES.FLOOR_PLANS,
    element: (
      <RouteGuard loggedOut>
        <FloorPlansScreen />
      </RouteGuard>
    ),
  },
  {
    path: ROUTES.FEATURED_VIDEOS,
    element: (
      <RouteGuard loggedOut>
        <FeaturedVideosScreen />
      </RouteGuard>
    ),
  },
  {
    path: `${ROUTES.REAL_ESTATE_COMPANIES}/edit`,
    element: (
      <RouteGuard loggedOut>
        <ManageRealEstateCompaniesEditScreen />
      </RouteGuard>
    ),
  },
  {
    path: ROUTES.REAL_ESTATE_COMPANIES,
    exact: true,
    element: (
      <RouteGuard loggedOut>
        <ManageRealEstateCompaniesMainScreen />
      </RouteGuard>
    ),
  },
  {
    path: ROUTES.PROPERTY.ADD,
    element: (
      <RouteGuard loggedOut>
        <PropertyEditScreen />
      </RouteGuard>
    ),
  },
  {
    path: ROUTES.PROPERTY.EDIT,
    element: (
      <RouteGuard loggedOut>
        <PropertyEditScreen />
      </RouteGuard>
    ),
  },
  {
    path: ROUTES.LINE.ADD,
    element: (
      <RouteGuard loggedOut>
        <LineEditScreen />
      </RouteGuard>
    ),
  },
  {
    path: ROUTES.LINE.EDIT,
    element: (
      <RouteGuard loggedOut>
        <LineEditScreen />
      </RouteGuard>
    ),
  },
  {
    path: ROUTES.UNITS.ADD,
    element: (
      <RouteGuard loggedOut>
        <UnitsEditScreen />
      </RouteGuard>
    ),
  },
  {
    path: ROUTES.UNITS.EDIT,
    element: (
      <RouteGuard loggedOut>
        <UnitsEditScreen />
      </RouteGuard>
    ),
  },
  {
    path: ROUTES.UNITS.MANAGE,
    element: (
      <RouteGuard loggedOut>
        <ManageLineUnitsScreen />
      </RouteGuard>
    ),
  },
  {
    path: ROUTES.DESIGNS.MANAGE,
    element: (
      <RouteGuard loggedOut>
        <ManageLineDesignsScreen />
      </RouteGuard>
    ),
  },
  {
    path: ROUTES.DESIGN_LAYOUTS.ADD,
    element: (
      <RouteGuard loggedOut>
        <DesignsEditScreen />
      </RouteGuard>
    ),
  },
  {
    path: ROUTES.DESIGN_LAYOUTS.EDIT,
    element: (
      <RouteGuard loggedOut>
        <DesignsEditScreen />
      </RouteGuard>
    ),
  },
  {
    path: ROUTES.ROOM_DESIGNS.ADD,
    element: (
      <RouteGuard loggedOut>
        <RoomDesignsEditScreen />
      </RouteGuard>
    ),
  },
  {
    path: ROUTES.ROOM_DESIGNS.EDIT,
    element: (
      <RouteGuard loggedOut>
        <RoomDesignsEditScreen />
      </RouteGuard>
    ),
  },
  {
    path: ROUTES.LEVEL.ADD,
    element: (
      <RouteGuard loggedOut>
        <LevelEditScreen />
      </RouteGuard>
    ),
  },
  {
    path: ROUTES.LEVEL.EDIT,
    element: (
      <RouteGuard loggedOut>
        <LevelEditScreen />
      </RouteGuard>
    ),
  },
  {
    path: ROUTES.PROPERTY.MANAGE,
    element: (
      <RouteGuard loggedOut>
        <ManagePropertyMainScreen />
      </RouteGuard>
    ),
  },
  {
    path: ROUTES.MANAGE_LINE_IMAGES,
    element: (
      <RouteGuard loggedOut>
        <ManagePropertyLineImagesScreen />
      </RouteGuard>
    ),
  },
  {
    path: ROUTES.PACKAGES.CREATE,
    element: (
      <RouteGuard loggedOut>
        <EditPackageScreen />
      </RouteGuard>
    ),
  },
  {
    path: ROUTES.PACKAGES.EDIT,
    element: (
      <RouteGuard loggedOut>
        <EditPackageScreen />
      </RouteGuard>
    ),
  },
  {
    path: ROUTES.PACKAGES.MANAGE,
    element: (
      <RouteGuard loggedOut>
        <ManagePackages />
      </RouteGuard>
    ),
  },
  {
    path: ROUTES.LIVING.VARIANTS.CREATE,
    element: (
      <RouteGuard loggedOut>
        <EditLivingVariantsScreen />
      </RouteGuard>
    ),
  },
  {
    path: ROUTES.LIVING.VARIANTS.EDIT,
    element: (
      <RouteGuard loggedOut>
        <EditLivingVariantsScreen />
      </RouteGuard>
    ),
  },
  {
    path: ROUTES.LIVING.VARIANTS.MANAGE,
    element: (
      <RouteGuard loggedOut>
        <ManageLivingVariantsScreen />
      </RouteGuard>
    ),
  },
  {
    path: ROUTES.MODELS_3D.CREATE,
    element: (
      <RouteGuard loggedOut>
        <Edit3DModelsScreen />
      </RouteGuard>
    ),
  },
  {
    path: ROUTES.MODELS_3D.EDIT,
    element: (
      <RouteGuard loggedOut>
        <Edit3DModelsScreen />
      </RouteGuard>
    ),
  },
  {
    path: ROUTES.MODELS_3D.MANAGE,
    element: (
      <RouteGuard loggedOut>
        <Manage3DModelsScreen />
      </RouteGuard>
    ),
  },
  {
    path: ROUTES.LIVING.DASHBOARD,
    element: (
      <RouteGuard loggedOut>
        <LivingDashboardScreen />
      </RouteGuard>
    ),
  },
  {
    path: ROUTES.LIVING.LINKS.CREATE,
    element: (
      <RouteGuard loggedOut>
        <EditLivingLinksScreen />
      </RouteGuard>
    ),
  },
  {
    path: ROUTES.LIVING.LINKS.EDIT,
    element: (
      <RouteGuard loggedOut>
        <EditLivingLinksScreen />
      </RouteGuard>
    ),
  },
  {
    path: ROUTES.IMAGES,
    element: (
      <RouteGuard loggedOut>
        <ImagesScreen />
      </RouteGuard>
    ),
  },
  {
    path: ROUTES.SIGNIN,
    element: (
      <RouteGuard loggedIn>
        <HeaderLayout>
          <SigninScreen />
        </HeaderLayout>
      </RouteGuard>
    ),
  },
  {
    path: '/*',
    element: <NotFoundScreen />,
  },
  {
    element: <Navigate to={ROUTES.HOME} />,
  },
]

export const location = new ReactLocation()

export const pageTitles = {}

export const navLinks = [
  {
    path: '',
    title: '',
  },
]
